// src/pages/AboutPage.tsx
import React from 'react';
import { Typography, Container, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AboutPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Container maxWidth="md">
            <Typography variant="h4" component="h1" gutterBottom>
                {t('title', { ns: 'about' })}
            </Typography>

            <Box mb={4}>
                <Typography variant="h5" gutterBottom>{t('mission_title', { ns: 'about' })}</Typography>
                <Typography variant="body1">
                    {t('mission_text', { ns: 'about' })}
                </Typography>
            </Box>

            <Box mb={4}>
                <Typography variant="h5" gutterBottom>{t('vision_title', { ns: 'about' })}</Typography>
                <Typography variant="body1">
                    {t('vision_text', { ns: 'about' })}
                </Typography>
            </Box>

            <Box>
                <Typography variant="h5" gutterBottom>{t('why_us_title', { ns: 'about' })}</Typography>
                <Typography variant="body1">
                    {t('why_us_text', { ns: 'about' })}
                </Typography>
            </Box>
        </Container>
    );
};

export default AboutPage;